import UserAvailable from "@/entities/filters/UserAvailable";

const contractorsCollectionFiltersTemplate = {
  name: "",
  countries: [],
  states: [],
  cities: [],
  available: "all" as UserAvailable,
  titles: [],
  skills: [],
  managers: [],
  projects: [],
  minRate: "",
  maxRate: "",
};

export default contractorsCollectionFiltersTemplate;